'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SearchMobile = require('./SearchMobile.scss');

var _SearchMobile2 = _interopRequireDefault(_SearchMobile);

var _reactIntl = require('react-intl');

var _DestinationSelect = require('components/General/DestinationSelect');

var _DestinationSelect2 = _interopRequireDefault(_DestinationSelect);

var _DatePicker = require('components/Calendar/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _search = require('redux/modules/search');

var _reactRedux = require('react-redux');

var _home = require('redux/modules/home');

var homeActions = _interopRequireWildcard(_home);

var _reactRouterRedux = require('react-router-redux');

var _lockscreen = require('redux/modules/lockscreen');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _search2 = require('utils/search');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SearchMobile: {
    displayName: 'SearchMobile'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/SearchTrips/SearchMobile.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Calendar from 'containers/Calendar/Calendar';


_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

// import _ from 'lodash';

var SearchMobile = _wrapComponent('SearchMobile')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destinations: state.info.destinations,
    destination: state.home.destination,
    // path: state.routing.locationBeforeTransitions.pathname,
    date: state.home.date,
    isFlexibleDate: state.home.isFlexibleDate,
    isOpenMobileNavSearch: state.home.isOpenMobileNavSearch,
    messages: state.language.messages,
    locale: state.language.locale,
    filter: state.search.filter,
    groupDestinationsByCountry: state.info.siteConfigs.groupDestinationsByCountry
  };
}, (0, _extends3.default)({}, homeActions, { addId: _lockscreen.addId, removeId: _lockscreen.removeId, push: _reactRouterRedux.push, prepFilter: _search.prepFilter, search: _search.search })), _dec2 = (0, _reactCssModules2.default)(_SearchMobile2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SearchMobile, _Component);

  function SearchMobile(props) {
    (0, _classCallCheck3.default)(this, SearchMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SearchMobile.__proto__ || (0, _getPrototypeOf2.default)(SearchMobile)).call(this, props));

    _this.close = _this.close.bind(_this);

    if (!(typeof _this.close === 'function')) {
      throw new TypeError('Value of "this.close" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.close));
    }

    _this.onChangeDestination = _this.onChangeDestination.bind(_this);

    if (!(typeof _this.onChangeDestination === 'function')) {
      throw new TypeError('Value of "this.onChangeDestination" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeDestination));
    }

    _this.onChangeDate = _this.onChangeDate.bind(_this);

    if (!(typeof _this.onChangeDate === 'function')) {
      throw new TypeError('Value of "this.onChangeDate" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeDate));
    }

    _this.onChangeFlex = _this.onChangeFlex.bind(_this);

    if (!(typeof _this.onChangeFlex === 'function')) {
      throw new TypeError('Value of "this.onChangeFlex" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeFlex));
    }

    _this.openCalendar = _this.openCalendar.bind(_this);

    if (!(typeof _this.openCalendar === 'function')) {
      throw new TypeError('Value of "this.openCalendar" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openCalendar));
    }

    _this.innerClick = _this.innerClick.bind(_this);

    if (!(typeof _this.innerClick === 'function')) {
      throw new TypeError('Value of "this.innerClick" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.innerClick));
    }

    _this.closeCalendar = _this.closeCalendar.bind(_this);

    if (!(typeof _this.closeCalendar === 'function')) {
      throw new TypeError('Value of "this.closeCalendar" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.closeCalendar));
    }

    _this.search = _this.search.bind(_this);

    if (!(typeof _this.search === 'function')) {
      throw new TypeError('Value of "this.search" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.search));
    }

    _this.state = {
      isOpenCalendar: false
    };
    return _this;
  }

  (0, _createClass3.default)(SearchMobile, [{
    key: 'onChangeDestination',
    value: function onChangeDestination(e) {
      this.props.setDestination(e.target.value);
    }
  }, {
    key: 'onChangeDate',
    value: function onChangeDate(date) {
      this.props.setDate(date);
      this.closeCalendar();
    }
  }, {
    key: 'onChangeFlex',
    value: function onChangeFlex(checked) {
      this.props.setFlexibleDate(checked);
      if (this.props.date && checked || !this.props.date && !checked) {
        this.closeCalendar();
      }
    }
  }, {
    key: 'openCalendar',
    value: function openCalendar() {
      this.setState({ isOpenCalendar: true });
    }
  }, {
    key: 'closeCalendar',
    value: function closeCalendar() {
      this.setState({ isOpenCalendar: false });
    }
  }, {
    key: 'innerClick',
    value: function innerClick(e) {
      e.stopPropagation();
    }
  }, {
    key: 'close',
    value: function close() {
      this.props.openMobileNavSearch(false);
    }
  }, {
    key: 'search',
    value: function search() {
      // const {destination, date, isFlexibleDate, path, filter} = this.props;
      var _props = this.props,
          destination = _props.destination,
          date = _props.date,
          isFlexibleDate = _props.isFlexibleDate;
      // console.log('PATH: ', path);
      // if (path.startsWith('/to/')) {
      //   const newFilter = {
      //     ...filter,
      //     date,
      //     location: destination,
      //     is_flexible_date: isFlexibleDate,
      //     skip: 0,
      //   };
      //   this.props.prepFilter(newFilter);
      //   this.props.search(newFilter);
      // } else {
      // const query = [];
      // let base = `/to/${destination ? destination : 'Any'}`;
      // if (date) {
      //   query.push(`date=${moment(date).format('DD-MM-YYYY')}`);
      // }
      // if (date && isFlexibleDate) {
      //   query.push('is_flexible_date=true');
      // }
      // if (query.length > 0) {
      //   base += `?${query.join('&')}`;
      // }
      // this.props.push(base);

      if (destination === 'Bangkok' || destination === 'Phuket' || destination === 'Chiang Mai') {
        window.location = 'https://experience.takemetour.com/' + destination;
      } else if (destination === 'Ayutthaya') {
        window.location = 'https://experience.takemetour.com/Bangkok/1?focus=ayutthaya-historical-park';
      } else if (destination === 'Kanchanaburi') {
        window.location = 'https://experience.takemetour.com/Bangkok/1?focus=kanchanaburi-death-railway';
      } else {
        this.props.push((0, _search2.parseFilterToQuery)({ location: destination, date: date, is_flexible_date: isFlexibleDate }));
        // }
        this.close();
        this.props.logSearch('mobile');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isOpenMobileNavSearch = _props2.isOpenMobileNavSearch,
          messages = _props2.messages,
          destinations = _props2.destinations,
          groupDestinationsByCountry = _props2.groupDestinationsByCountry;
      var _props3 = this.props,
          destination = _props3.destination,
          date = _props3.date,
          isFlexibleDate = _props3.isFlexibleDate;
      var isOpenCalendar = this.state.isOpenCalendar;

      var dayDiff = (0, _momentTimezone2.default)(date).diff((0, _momentTimezone2.default)().startOf('day'), 'day');
      return _react3.default.createElement(
        'div',
        { styleName: isOpenMobileNavSearch ? 'open' : 'close' },
        _react3.default.createElement(
          'div',
          { styleName: 'header-container' },
          _react3.default.createElement('a', { onClick: this.close, styleName: 'btn-close' })
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'content-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'section' },
            _react3.default.createElement(
              'h3',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.select_dropdown.dropdown_placeholder' })
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'dropdown-select' },
              _react3.default.createElement(_DestinationSelect2.default, {
                locale: this.props.locale,
                messages: {
                  popular_cities: messages['nav.select_dropdown.dropdown_placeholder.popular_cities'],
                  cities: messages['nav.select_dropdown.dropdown_placeholder.cities']
                },
                groupDestinationsByCountry: groupDestinationsByCountry,
                onSelect: this.onChangeDestination,
                placeholder: messages['nav.select_dropdown.dropdown_placeholder2'],
                destinations: destinations
              }),
              destination ? _react3.default.createElement(
                'span',
                null,
                destination
              ) : [_react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.select_dropdown.dropdown_placeholder2', key: 'des-0' }), _react3.default.createElement('div', { styleName: 'dropdown-arrow', key: 'des-1' })]
            )
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'section' },
            _react3.default.createElement(
              'h3',
              null,
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'datepicker.when' }),
              '?'
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'date-container', onClick: this.openCalendar },
              date ? _react3.default.createElement(
                'span',
                null,
                dayDiff === 0 && 'Today',
                dayDiff === 1 && 'Tomorrow',
                dayDiff !== 0 && dayDiff !== 1 && (0, _momentTimezone2.default)(date).format('LL')
              ) : [_react3.default.createElement(
                'span',
                { key: 'date-0' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'datepicker.any_date_c' })
              ), _react3.default.createElement('div', { styleName: 'dropdown-arrow', key: 'date-1' })]
            )
          ),
          _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
              'a',
              { styleName: 'btn-search', onClick: this.search },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'search.search_filter.search.label' })
            )
          )
        ),
        isOpenCalendar && _react3.default.createElement(
          'div',
          { styleName: 'calendar-open', onClick: this.closeCalendar },
          _react3.default.createElement(
            'div',
            { styleName: 'calendar-inner', onClick: this.innerClick },
            _react3.default.createElement(_DatePicker2.default, { date: date, isFlexibleDate: isFlexibleDate, onChangeDate: this.onChangeDate, onChangeFlex: this.onChangeFlex })
          )
        )
      );
    }
  }]);
  return SearchMobile;
}(_react2.Component), _class2.propTypes = {
  messages: _react2.PropTypes.object,
  // path: PropTypes.string,
  locale: _react2.PropTypes.string,
  destinations: _react2.PropTypes.array,
  groupDestinationsByCountry: _react2.PropTypes.bool,
  addId: _react2.PropTypes.func,
  removeId: _react2.PropTypes.func,
  isOpenMobileNavSearch: _react2.PropTypes.bool,
  openMobileNavSearch: _react2.PropTypes.func,
  destination: _react2.PropTypes.string,
  filter: _react2.PropTypes.object,
  date: _react2.PropTypes.any,
  isFlexibleDate: _react2.PropTypes.bool,
  setDestination: _react2.PropTypes.func,
  setDate: _react2.PropTypes.func,
  setFlexibleDate: _react2.PropTypes.func,
  push: _react2.PropTypes.func,
  search: _react2.PropTypes.func,
  logSearch: _react2.PropTypes.func,
  prepFilter: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = SearchMobile;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SearchTrips/SearchMobile.js
// module id = 1619
// module chunks = 47